import { render } from "./AdminLoginLayout.vue?vue&type=template&id=b28bbade"
import script from "./AdminLoginLayout.vue?vue&type=script&lang=js"
export * from "./AdminLoginLayout.vue?vue&type=script&lang=js"

import "./AdminLoginLayout.vue?vue&type=style&index=0&id=b28bbade&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__